export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./chatArea.vue?vue&type=template&id=7bb8dcb2&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/chatArea.vue?vue&type=template&id=7bb8dcb2&scoped=true&
// module id = null
// module chunks = 